
















import Vue from 'vue'
import _ from 'lodash'

export default Vue.extend({
  name: 'UiTransition',
  props: ['name'],
  mounted () {
  },
  data () {
    return {
      uid: _.random(1000, 9999999)
    }
  },
  methods: {
    setHeight (el: HTMLElement) {
      if (!el.classList.contains('uiTransition-' + this.uid)) {
        el.classList.add('uiTransition-' + this.uid)
      }
      el.style.position = 'absolute'
      el.style.visibility = 'hidden'

      const height = getComputedStyle(el).height
      console.dir(el)
      console.log(height, el.clientWidth, el.scrollHeight)

      el.style.position = null
      el.style.visibility = null

      Vue.set(this.$store.state.appInterface.styles, this.uid, {
        query: '.uiTransition-' + this.uid + '.slideUp-enter-to, .uiTransition-' + this.uid + '.slideUp-leave',
        params: {
          height: el.scrollHeight + 'px',
          overflow: 'hidden'
        }
      })
    },

    beforeEnter: function (el: HTMLElement) {
    },
    enter: function (el: HTMLElement, done: () => void) {
    },
    afterEnter: function (el: HTMLElement) {
    },
    enterCancelled: function (el: HTMLElement) {
      // ...
    },

    beforeLeave: function (el: HTMLElement) {
      // ...
    },
    leave: function (el: HTMLElement, done: () => void) {
      // ...
      done()
    },
    afterLeave: function (el: HTMLElement) {
      // ...
    },
    leaveCancelled: function (el: HTMLElement) {
      // ...
    }
  }
})
